import axios from "../../../axios"
import { getCurrentTenant, formatGraphqlBody, formatGraphqlParams, parseObjectParamsToString } from '@/utils'

export default {
  fetch(searchParams = '') {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          metaMessageTemplates ${ parseObjectParamsToString(searchParams) } {
            id
            name,
            meta_id,
            language,
            status,
            category,
            components {
              type,
              text,
              format,
              buttons {
                type,
                text,
                url
              }
            }
          }
        }
      `
    })
  },
  add(metaMessageTemplate) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    const params = formatGraphqlParams({
      name: metaMessageTemplate.name,
      category: metaMessageTemplate.category,
      components: metaMessageTemplate.components
    });

    return axios.post('', formatGraphqlBody(
      'mutation',
      'createMetaMessageTemplate',
      {
        0: 'id',
        components: {
          0: 'type',
          1: 'text',
          2: 'format'
        },
        1: 'name',
        2: 'meta_id',
        3: 'language',
        4: 'status',
        5: 'category'
      },
      params
    ))
  },
  send(messageTemplate) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    const params = formatGraphqlParams({
      message_template_name: messageTemplate.message_template_name,
      official_params: messageTemplate.official_params,
      to_number: messageTemplate.to_number,
      instance_id: messageTemplate.instance_id,
      user_id: messageTemplate.user_id,
      from_chat: true
    });

    return axios.post('', formatGraphqlBody(
      'mutation',
      'sendMetaMessageTemplate',
      null,
      params
    ))
  },
  update(metaMessageTemplate) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    const params = formatGraphqlParams({
      id: metaMessageTemplate.id,
      category: metaMessageTemplate.category,
      components: metaMessageTemplate.components
    });

    return axios.post('', formatGraphqlBody(
        'mutation',
        'updateMetaMessageTemplate',
        {
          0: 'id',
          components: {
            0: 'type',
            1: 'text',
            2: 'format'
          },
          1: 'name',
          2: 'meta_id',
          3: 'language',
          4: 'status',
          5: 'category'
        },
        params
    ))
  },
  delete(id) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
    return axios.post('', {
      query: `
        mutation {
          deleteMetaMessageTemplate (
              id: ${id}
          )
        }
      `
    })
  },
  count(template){
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
    return axios.post('', {
      query: `
        query {
          metaMessageTemplateCount (
              name: "${template.name}"
          )
        }
      `
    })
  }
}
